import styles from './ControlBar.module.css';

function formatClockPart(value: number) {
  return value.toString().padStart(2, '0');
}

export function formatPlaybackTime(totalSeconds: number) {
  const safeSeconds = Math.max(0, Math.floor(totalSeconds));
  const hours = Math.floor(safeSeconds / 3600);
  const minutes = Math.floor((safeSeconds % 3600) / 60);
  const seconds = safeSeconds % 60;

  if (hours > 0) {
    return `${hours}:${formatClockPart(minutes)}:${formatClockPart(seconds)}`;
  }

  return `${minutes}:${formatClockPart(seconds)}`;
}

interface TimeDisplayProps {
  currentTime: number;
  duration: number;
}

export function TimeDisplay({ currentTime, duration }: TimeDisplayProps) {
  return (
    <p aria-label="Playback time" className={styles.time}>
      {formatPlaybackTime(currentTime)} / {formatPlaybackTime(duration)}
    </p>
  );
}
